import {
  Button,
  createStyles,
  Dialog,
  IconButton,
  LinearProgress,
  Table,
  TableContainer,
  Theme,
  Typography,
  WithStyles,
} from "@material-ui/core";
import Moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import { GlobalState } from "../../types/globalState";
import GameActions from "../../actions/games";
import HandicapActions from "../../actions/handicaps";
import ModernScoreCardView from "../ScoreCard/ModernScoreCardView";
import { Close } from "@material-ui/icons";
import { Game, IndexedGames, Leaderboard } from "../../types/game";
import { showAlertDialog } from "../SharedComponents/AlertDialog";
import ScoreCardView from "../ScoreCard/ScoreCardSubmition";
import { Player } from "../../types/player";
import { showSnackbar } from "../SharedComponents/Notifier";
import Config from "../../config";
import * as socket from "../../socket";
import { User, UserBrifObj } from "../../types/user";
import LeaderboardUnavailable from "./LeaderboardUnavailable";
import { playerCustomHandicap } from "../../types/handicpas";
import { AxiosError } from "axios";
import { Competition, PlayingAsFormats } from "./../../types/competition";
import { isCombinedGame } from "./../../utils/index";
import { gameShowsHandicapAdjustment } from "../../utils/gameHandicapSource";
import LeaderboardToolbar from "./LeaderboardToolbar";
import LeaderboardActions from "./LeaderboardActions";
import TeamLeaderboard from "./TeamLeaderboard";
import PlayersLeaderboard from "./PlayersLeaderboard";
import AdvertSection from "components/Adverts/GameAdvert";
import { ADVERT_VALUES } from "consts";
import { AdvertTypes } from "types/advert";
import { isGameStandard, scrollTo } from "utils";
import { withScroll, WithScrollState } from "utils/withScroll";
import { StartSheet } from "components/Game/GameStartSheet";
import TournamentActions from "../../actions/tournaments";
import TournamentLeaderboard from "../TournamentLeaderboard";
import { Tournament } from "../../types/tournament";
import LinkedTournamentsPicker from "./LinkedTournamentsPicker";
import LeaderboardContextBar from "./LeaderboardContextBar";
import { updateAuxiliaryDialogMeta } from "../SharedComponents/AuxiliaryDialog";
import DialogPresentationContext, {
  DialogPresentationContextValue,
} from "../SharedComponents/DialogPresentationContext";
import TournamentTrophyIcon, { TOURNAMENT_HEADER_TROPHY_WIDTH } from "../SharedComponents/TournamentTrophyIcon";

type LeaderboardViewMode = "game" | "tournament";

export interface IndividualLeaderBoardOwnProps {
  gameId?: string;
  activeUserId?: string;
  games?: IndexedGames;
  finalCheck?: boolean;
}

interface Props extends IndividualLeaderBoardOwnProps, WithStyles {
  match?: { params: { gameId?: string } };
  getGameById(
    id: string,
    queryType?: string,
    updateRedux?: boolean,
    callback?: (err: AxiosError | null, data: Game) => void,
  ): void;
  getHandicapsByRuleId(id: string, callback: (err: AxiosError | null, data: playerCustomHandicap[]) => void): void;
  getGameByCode(code: string, queryType: string, callback?: (error: AxiosError | null, data?: Game) => void): void;
  addGameToVisitedLeaderBoard(game: any): void;
  setUpdatedResult(game: any): void;
  setGameFinished(gameId: string): void;
  revealLeaderboard(gameId: string, callback?: any): void;
  setLeaderboardRevealResult(game: any): void;
  loading: boolean;
  user: User;
  startScroll: (data: WithScrollState) => void;
  getTournamentGames(tournamentId: string, callback?: (err: AxiosError | null) => void): void;
}

export interface PositionsInfo {
  position: number | string;
  showInfo: boolean;
  showInTwoSteps: boolean;
}
interface State {
  openDialog: string;
  player?: any;
  teammates?: Player[];
  game?: any;
  offlineMode: boolean;
  isGameClosed: boolean;
  displayPageRefresh: boolean;
  getGameByIdQueryType: string;
  isLeaderboard: boolean;
  leaderboardView: LeaderboardViewMode;
  activeTournament: Tournament | null;
  tournamentPickerOpen: boolean;
  tournamentLoading: boolean;
}

let closeDialog = (_player?: Player) => {};

class individualLeaderBoard extends Component<Props, State> {
  static contextType = DialogPresentationContext;

  mainRef = React.createRef<HTMLDivElement>();
  trRefs = React.createRef<HTMLTableRowElement[]>() as React.MutableRefObject<HTMLTableRowElement[]>;

  constructor(props: Props) {
    super(props);
    this.trRefs.current = [];
    this.state = {
      game: null,
      openDialog: "",
      isGameClosed: false,
      offlineMode: false,
      displayPageRefresh: false,
      getGameByIdQueryType: "all",
      isLeaderboard: true,
      leaderboardView: "game",
      activeTournament: null,
      tournamentPickerOpen: false,
      tournamentLoading: false,
    };
  }

  componentDidMount = () => {
    this.loadData((game: Game) => {
      this.startScrolling(game.leaderboard);
    });
    closeDialog = this.closeScoreCardDialog;
  };

  componentWillUnmount() {
    socket.disconnect();
    // Do not clear the auxiliary toolbar here — unmount also runs when another
    // auxiliary dialog replaces this content (e.g. tournament round breakdown),
    // which would wipe the new dialog's title/subtitle.
  }

  componentDidUpdate(_prevProps: Props, prevState: State) {
    if (this.isRouteView()) return;

    const shouldSync =
      prevState.leaderboardView !== this.state.leaderboardView ||
      prevState.activeTournament !== this.state.activeTournament ||
      prevState.game !== this.state.game ||
      prevState.isLeaderboard !== this.state.isLeaderboard ||
      prevState.isGameClosed !== this.state.isGameClosed;

    if (shouldSync) {
      this.syncDialogHeader();
    }
  }

  isRouteView = () => Boolean(this.props.match?.params?.gameId);

  formatTournamentSeasonRange = (tournament: Tournament) =>
    `${Moment(tournament.seasonStart).format("ll")} – ${Moment(tournament.seasonEnd).format("ll")}`;

  clearDialogHeader = () => {
    updateAuxiliaryDialogMeta("", "", false, "");
  };

  syncDialogHeader = () => {
    if (this.isRouteView()) return;

    const { leaderboardView, activeTournament, game, isLeaderboard, isGameClosed } = this.state;

    if (leaderboardView === "tournament" && activeTournament) {
      const subtitle = this.formatTournamentSeasonRange(activeTournament);
      updateAuxiliaryDialogMeta(activeTournament.name, subtitle, true);
      return;
    }

    if (!game) {
      this.clearDialogHeader();
      return;
    }

    const viewLabel = isLeaderboard ? "Leaderboard" : "Start sheet";
    const subtitle = `${Moment(game.date).format("ll")} · ${viewLabel}`;

    updateAuxiliaryDialogMeta(game.name, subtitle, false, "");
  };

  handlePageRefreshAdvert = (val: boolean) => {
    this.setState({ displayPageRefresh: val });
  };

  startScrolling = (leaderboard?: Leaderboard) => {
    if (!leaderboard) return;

    const widescreenActive = Boolean(leaderboard.widescreen);

    this.props.startScroll({
      fields: { ...leaderboard, widescreen: widescreenActive },
      containerEl: this.mainRef.current || undefined,
      tableRowEl: this.trRefs.current?.[0],
      setPageRefreshVisibility: widescreenActive ? this.handlePageRefreshAdvert : undefined,
    });
  };

  onGameUpdated = (result: any) => {
    this.setState((state: State) => ({ ...state, game: { ...state.game, players: result.players } }));
    this.props.setUpdatedResult(result);
  };

  onLeaderboardRevealed = (result: any) => {
    this.setState(
      (state: State) => ({ ...state, game: { ...state.game, leaderboard: result.leaderboard } }),
      () => {
        const index = result.leaderboard.revealIndex;
        const trEl = this.trRefs.current?.[index - 1];
        const containerEl = this.mainRef.current;
        if (!trEl || !containerEl) return;

        const { height: rowHeight } = trEl.getBoundingClientRect();

        if (index > 3 && !result.leaderboard.showInTwoSteps)
          scrollTo(containerEl, containerEl.scrollTop + rowHeight, 1000, false);
      },
    );
    this.props.setLeaderboardRevealResult(result);
  };

  onPresentationUpdate = ({ leaderboard }: { leaderboard: Leaderboard }) => {
    this.setState((state: State) => ({ ...state, game: { ...state.game, leaderboard } }));
    this.startScrolling(leaderboard);
  };

  connectToWebsocket = (gameId: any) => {
    if (socket.connect(gameId)) {
      socket.addEvent(socket.EVENTS.SCORES_UPDATED, this.onGameUpdated);
      socket.addEvent(socket.EVENTS.PLAYERS_CHANGED, this.onGameUpdated);
      socket.addEvent(socket.EVENTS.LEADERBOARD_REVEAL, this.onLeaderboardRevealed);
      socket.addEvent(socket.EVENTS.PRESENTATION_UPDATED, this.onPresentationUpdate);
    } else this.setState({ offlineMode: true });
  };

  reconnect = () => {
    this.props.gameId && this.connectToWebsocket(this.props.gameId);
  };

  loadData = (cb?: (game: Game) => void) => {
    if (this.props.gameId) {
      this.getGame(this.state.getGameByIdQueryType, cb);
      this.connectToWebsocket(this.props.gameId);
    } else {
      this.getGameByGameCode(cb);
    }
  };

  getGameByGameCode = (cb?: (game: Game) => void) => {
    const gameCode = this.props.match?.params?.gameId;
    if (gameCode) {
      this.props.getGameByCode(gameCode, this.state.getGameByIdQueryType, (err, game) => {
        if (err) {
          if (err.response && err.response.status === 404) {
            showSnackbar("Game Code is invalid!");
          }
        } else if (game) {
          this.connectToWebsocket(game._id);
          this.setState({ game });
          if (cb) cb(game);
          this.props.addGameToVisitedLeaderBoard(game);
        }
      });
    }
  };

  getGame = (queryType?: string, cb?: (game: Game) => void) => {
    const gameId = this.props.gameId || this.state.game?._id;
    if (!gameId) return;

    this.props.getGameById(gameId, queryType, false, (err, game) => {
      if (!err) {
        this.setState({ game });

        if (cb) cb(game);
      }
    });
  };
  summation(list: any[], key?: string) {
    return list.reduce((total: any, e: any) => {
      if (key) {
        if (typeof e[key] === "number") return total + e[key];
      } else {
        if (typeof e === "number") return total + e;
      }
      return total;
    }, 0);
  }
  getScoreCard(player: any) {
    const { game } = this.state;
    if (!game) return null;

    if (player.teeColor) return game.scoreCards[player.teeColor.scoreCardId];
    return game.scoreCards[0];
  }

  getScoringFormat = () => {
    const { game } = this.state;
    return typeof game?.competition === "object" ? game.competition.scoringFormat.toString() : "undefined";
  };

  isAllCardsFilled = (game: Game) => {
    let isAlCardsField = true;
    const isCombined = isCombinedGame(game.competition);
    const players = Object.values(game.players).filter(x => x.isTeamCard || !isCombined);
    players.forEach(player => {
      if (Object.values(player.holes).length !== game.competition.holesNumber) {
        isAlCardsField = false;
        return;
      }
    });
    return isAlCardsField;
  };

  handleGameClosed = () => {
    const { getGameByIdQueryType } = this.state;
    this.getGame(getGameByIdQueryType);
    this.setState({ isGameClosed: true });
  };

  openScoreCardDialog = (player?: Player, teammates?: Player[]) => {
    if (this.state.game.organizers.filter((o: UserBrifObj) => o._id === this.props.user._id).length === 0) {
      this.setState({
        openDialog: "viewCard",
        player: player,
      });
    } else {
      showAlertDialog(
        "Submission",
        "Review Submission Card.",
        () => {
          this.setState({
            openDialog: "submitionCard",
            player: player,
          });
        },
        () => {
          this.setState({
            openDialog: "viewCard",
            player: player,
            teammates,
          });
        },
      );
    }
  };
  closeScoreCardDialog = () => {
    this.loadData();
    this.setState({ openDialog: "" });
  };
  renderPlayerScoreCardViewDialog() {
    if (!this.state.player) return null;
    return (
      <>
        <Dialog open={this.state.openDialog === "submitionCard"} fullScreen onBackdropClick={this.closeScoreCardDialog}>
          <ScoreCardView player={this.state.player} game={this.state.game} closeDialog={this.closeScoreCardDialog} />
        </Dialog>
        <Dialog open={this.state.openDialog === "viewCard"} onBackdropClick={this.closeScoreCardDialog}>
          <div>
            <IconButton style={{ float: "right" }} onClick={this.closeScoreCardDialog}>
              <Close />
            </IconButton>
          </div>
          <ModernScoreCardView player={this.state.player} teammates={this.state.teammates} game={this.state.game} />
        </Dialog>
      </>
    );
  }

  checkPresentationMode = (game: Game, index: number) => {
    const { leaderboard } = game;
    if (leaderboard && leaderboard.presentationMode) {
      if (index >= leaderboard.hideUntil || !leaderboard.hideUntil) return true;
      if (leaderboard.revealIndex !== undefined) {
        if (leaderboard.reverseHiddenPlace) return index >= leaderboard.revealIndex;
        else return index < leaderboard.revealIndex;
      }
      return false;
    }
    return true;
  };

  showInTwoSteps = (game: Game, index: number) => {
    const { leaderboard } = game;
    if (
      leaderboard &&
      leaderboard.presentationMode &&
      leaderboard.revealPlaceStatus === Config.LEADERBOARD_CONFIG.REVEAL_HIDDEN_PLACES.TWO_STEP &&
      leaderboard.showInTwoSteps
    ) {
      if (leaderboard.reverseHiddenPlace) return index === leaderboard.revealIndex;
      else return index + 1 === leaderboard.revealIndex;
    }
    return false;
  };

  isTeamGame = (competition: Competition) =>
    competition.playingRules && competition.playingRules.playingAs === PlayingAsFormats.Team;

  calculatePosition = (player: any, index: number, lastPlayerPoint: number | string): PositionsInfo => {
    const { game } = this.state;
    let position: number | string = index + 1;
    const sharedPrize = game.competition?.handicapRules?.sharedPrize;
    const showInfo = this.checkPresentationMode(game, index);
    const showInTwoSteps = this.showInTwoSteps(game, index);
    if ((sharedPrize && player.pts === lastPlayerPoint) || player.disqualified) position = "";
    return { position, showInfo, showInTwoSteps };
  };

  onRevealButtonClicked = async (gameId: any, revealStatus: any) => {
    this.props.revealLeaderboard(gameId);
  };

  haveAccessToLeaderboard = (game: Game, user: User) => {
    if (game.state === "done") return true;
    if (game.leaderboard && user.rule !== Config.RULES.ADMIN)
      switch (game.leaderboard.activateStatus) {
        case Config.LEADERBOARD_CONFIG.ACTIVATED.EVERY_ONE:
          return true;
        case Config.LEADERBOARD_CONFIG.ACTIVATED.VIEW_ONLY:
          return game.players[user._id || ""] === undefined;
        case Config.LEADERBOARD_CONFIG.ACTIVATED.ORGANIZER_ONLY:
          return user.rule === Config.RULES.ORGANIZER && game.organizers.findIndex(o => o._id === user._id) !== -1;
      }
    return true;
  };

  isStandardGame = () => isGameStandard(this.state.game.competition.type);

  handleIsLeaderboardChange = (isLeaderboard: boolean) => this.setState({ isLeaderboard });

  getLinkedTournaments = (): Tournament[] => {
    const tournaments = this.state.game?.tournaments;
    if (!tournaments?.length) return [];
    return tournaments.filter((t: Tournament) => t && t._id);
  };

  handleTournamentLinkClick = () => {
    const linked = this.getLinkedTournaments();
    if (!linked.length) return;
    if (linked.length === 1) {
      this.openTournamentLeaderboard(linked[0]);
      return;
    }
    this.setState({ tournamentPickerOpen: true });
  };

  openTournamentLeaderboard = (tournament: Tournament) => {
    this.setState({ tournamentPickerOpen: false, tournamentLoading: true });
    socket.disconnect();

    this.props.getTournamentGames(tournament._id, err => {
      if (err) {
        this.setState({ tournamentLoading: false });
        return;
      }
      this.setState({
        tournamentLoading: false,
        leaderboardView: "tournament",
        activeTournament: tournament,
      });
    });
  };

  backToGameLeaderboard = () => {
    const { game } = this.state;
    this.setState({
      leaderboardView: "game",
      activeTournament: null,
      tournamentPickerOpen: false,
    });
    if (game?._id) {
      this.connectToWebsocket(game._id);
      this.startScrolling(game.leaderboard);
    }
  };

  renderTournamentView = () => {
    const { classes } = this.props;
    const { game, activeTournament, tournamentLoading } = this.state;
    if (!activeTournament || !game) return null;

    const isRouteView = this.isRouteView();

    return (
      <main className={`${classes.main} ${classes.mainEmbedded} ${classes.mainInDialog}`}>
        {isRouteView ? (
          <div className={classes.tournamentPageHeader}>
            <div className={classes.tournamentPageTitleBlock}>
              <div className={classes.tournamentPageTrophyWrap}>
                <TournamentTrophyIcon fillHeight />
              </div>
              <div className={classes.tournamentPageTitleText}>
                <Typography className={classes.tournamentPageTitle} variant="subtitle1" component="h1" noWrap>
                  {activeTournament.name}
                </Typography>
                <Typography className={classes.tournamentPageSubtitle} component="p" noWrap>
                  {this.formatTournamentSeasonRange(activeTournament)}
                </Typography>
              </div>
            </div>
          </div>
        ) : null}
        <LeaderboardContextBar
          label={`Back to ${game.name}`}
          onBack={this.backToGameLeaderboard}
        />
        {tournamentLoading ? (
          <LinearProgress />
        ) : (
          <TournamentLeaderboard tournament={activeTournament} embedded />
        )}
      </main>
    );
  };

  render() {
    const { classes, loading, user } = this.props;
    const { game, offlineMode, isLeaderboard, leaderboardView } = this.state;
    if (!game || !game.competition) return <LinearProgress />;
    if (!game.players) return <p>There was no player on this game!</p>;

    if (leaderboardView === "tournament") {
      return (
        <>
          {this.renderTournamentView()}
          <LinkedTournamentsPicker
            open={this.state.tournamentPickerOpen}
            tournaments={this.getLinkedTournaments()}
            onClose={() => this.setState({ tournamentPickerOpen: false })}
            onSelect={this.openTournamentLeaderboard}
          />
        </>
      );
    }

    const linkedTournaments = this.getLinkedTournaments();
    const { competition } = game;
    const isFinalScore = game.state === "done" || this.state.isGameClosed;
    const isStroke = this.getScoringFormat() === Config.SCORING_FORMAT.STROKE;
    const isTeamGame = this.isTeamGame(competition);
    const isCombined = isCombinedGame(competition);
    const isTeamLeaderboard = isTeamGame && !isCombined;
    const widescreen = game.leaderboard?.widescreen;
    const isOrganizer = game.organizers.findIndex((o: UserBrifObj) => o._id === user._id) !== -1;

    if (!this.haveAccessToLeaderboard(game, user)) return <LeaderboardUnavailable />;

    const handleQueryTypeChanged = (type: string) => {
      this.setState({ getGameByIdQueryType: type });
      this.getGame(type);
    };

    const isInDialog = !this.isRouteView();
    const dialogPresentation = this.context as DialogPresentationContextValue | null;
    const presentWidescreen = Boolean(
      widescreen && (this.isRouteView() || dialogPresentation?.isFullscreen),
    );

    return (
      <main
        className={`${classes.main} ${presentWidescreen ? "wide" : ""} ${isInDialog ? classes.mainInDialog : ""}`}
      >
        {loading && <LinearProgress />}
        {offlineMode && (
          <Button color="secondary" variant={"contained"} fullWidth onClick={this.reconnect}>
            Reconnect
          </Button>
        )}
        <LeaderboardToolbar
          name={game.name}
          code={game.code}
          date={game.date}
          isFinalScore={isFinalScore}
          widescreen={presentWidescreen}
          isLeaderboard={isLeaderboard}
          showSwitchButton={this.isRouteView()}
          titleInDialog={isInDialog}
          handleIsLeaderboardChange={this.handleIsLeaderboardChange}
        />
        <LinkedTournamentsPicker
          open={this.state.tournamentPickerOpen}
          tournaments={linkedTournaments}
          onClose={() => this.setState({ tournamentPickerOpen: false })}
          onSelect={this.openTournamentLeaderboard}
        />
        {isLeaderboard ? (
          <>
            <LeaderboardActions
              game={game}
              user={user}
              multipleQueryType={isTeamLeaderboard && !isCombined}
              queryType={this.state.getGameByIdQueryType}
              onQueryTypeChanged={handleQueryTypeChanged}
              isGameClosed={this.state.isGameClosed}
              onRevealButtonClicked={this.onRevealButtonClicked}
              onGameClosed={this.handleGameClosed}
              widescreen={presentWidescreen}
              showTournamentLink={linkedTournaments.length > 0}
              onTournamentLinkClick={this.handleTournamentLinkClick}
            />

            <TableContainer
              className={`${classes.tableContainer} ${presentWidescreen ? "wide" : ""}`}
              ref={this.mainRef}
            >
              <Table id="leaderboard" className={classes.leaderboard} stickyHeader>
                {isTeamLeaderboard ? (
                  <TeamLeaderboard
                    widescreen={presentWidescreen}
                    isOrganizer={isOrganizer}
                    trRefs={this.trRefs}
                    openScoreCardDialog={this.openScoreCardDialog}
                    calculateTeamPosition={this.calculatePosition}
                    game={game}
                    teams={game.teams}
                    isStroke={isStroke}
                  />
                ) : (
                  <PlayersLeaderboard
                    gameInfo={{
                      isStroke,
                      isFinalScore,
                      isPaidGame: game.isPaid,
                      isStandardGame: this.isStandardGame(),
                      isCombined,
                      scoresDisplayOrder: game.leaderboard?.scoresDisplayOrder,
                      shouldPayBeforePlay: game.paymentRules?.payBeforePlay,
                      exactHandicaps: competition.handicapRules.exactHandicaps,
                      handicapAdjustment: gameShowsHandicapAdjustment(game),
                      holesNumber: competition.holesNumber,
                      verifyQs: game.verifyQs,
                      widescreen: presentWidescreen,
                    }}
                    players={game.players}
                    calculatePlayerPosition={this.calculatePosition}
                    activeUserId={this.props.activeUserId || user._id}
                    openScoreCardDialog={this.openScoreCardDialog}
                    isOrganizer={isOrganizer}
                    trRefs={this.trRefs}
                  />
                )}
              </Table>
            </TableContainer>
            {this.renderPlayerScoreCardViewDialog()}
            {presentWidescreen && (
              <AdvertSection
                clubLogo={game.course.club.logo}
                gameId={game._id}
                type={AdvertTypes.LEADER_BOARD}
                displayPageRefresh={this.state.displayPageRefresh}
              />
            )}
          </>
        ) : (
          <StartSheet
            gameId={game._id}
            games={this.props.games ? this.props.games : { [game._id]: game }}
            downloadable={isOrganizer}
          />
        )}
      </main>
    );
  }
}

const styles = (theme: Theme) =>
  createStyles({
    main: {
      position: "relative",
      width: "auto",
      minWidth: 300,
      maxWidth: 640,
      backgroundColor: "#FFF",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      height: "100%",

      "&.wide": {
        minWidth: "100%",
        maxWidth: "100%",

        [theme.breakpoints.up("lg")]: {
          "& h2,h3,p,strong,td": {
            fontSize: "1.2em",
          },
          "& button.MuiButton-root": {
            fontSize: "1.1em",
          },
          "& th, td.MuiTableCell-body ": {
            fontSize: "1.3rem",
          },
        },
        [theme.breakpoints.up("xl")]: {
          "& h2,h3,p,strong,td": {
            fontSize: "1.4em",
          },
          "& button.MuiButton-root": {
            fontSize: "1.2em",
          },
          "& th, td.MuiTableCell-body ": {
            fontSize: "1.8rem",
          },
        },
      },

      [theme.breakpoints.up(550 + theme.spacing(6))]: {
        minWidth: 520,
        width: "fit-content",
        marginLeft: "auto",
        marginRight: "auto",
      },

      "&$mainInDialog": {
        maxWidth: "100%",
        width: "100%",
        minWidth: 0,
        marginLeft: 0,
        marginRight: 0,

        [theme.breakpoints.up(550 + theme.spacing(6))]: {
          width: "100%",
          minWidth: 0,
          marginLeft: 0,
          marginRight: 0,
        },
      },
    },
    headerCell: {
      fontWeight: "bold",
    },
    leaderboard: {
      backgroundColor: "#FFF",
    },
    tableContainer: {
      height: "auto",
      flex: 1,
      paddingBottom: 65,

      "&.wide": {
        [theme.breakpoints.up("md")]: {
          paddingBottom: ADVERT_VALUES.HEIGHT,
          paddingRight: ADVERT_VALUES.SIDEBAR_WIDTH,
        },
      },
    },
    mainEmbedded: {
      maxWidth: "100%",
      width: "100%",
    },
    mainInDialog: {
      minWidth: 0,
      maxWidth: "100%",
      width: "100%",
      flex: 1,
      minHeight: 0,
    },
    tournamentPageHeader: {
      width: "100%",
      boxSizing: "border-box",
      padding: theme.spacing(1.5, 2, 0.75),
      borderBottom: `1px solid rgba(226, 232, 240, 0.95)`,
      backgroundColor: "#ffffff",
    },
    tournamentPageTitleBlock: {
      display: "flex",
      alignItems: "stretch",
      gap: theme.spacing(1.5),
      minWidth: 0,
    },
    tournamentPageTrophyWrap: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flex: `0 0 ${TOURNAMENT_HEADER_TROPHY_WIDTH}px`,
      width: TOURNAMENT_HEADER_TROPHY_WIDTH,
      minHeight: 40,
      overflow: "hidden",
    },
    tournamentPageTitleText: {
      flex: 1,
      minWidth: 0,
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    tournamentPageTitle: {
      minWidth: 0,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      fontSize: "1.125rem",
      fontWeight: 600,
      lineHeight: 1.3,
      color: "#0f172a",
      margin: 0,
    },
    tournamentPageSubtitle: {
      margin: theme.spacing(0.375, 0, 0),
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      fontSize: "0.8125rem",
      fontWeight: 400,
      lineHeight: 1.4,
      color: "#64748b",
    },
  });
const mapStateToProps = (state: GlobalState) => {
  const { loading } = state.general;
  const { user } = state.auth;
  return {
    user,
    loading,
  };
};

const LeaderboardWithScroll = withScroll(individualLeaderBoard);

export { closeDialog };

const ConnectedIndividualLeaderBoard = connect(mapStateToProps, {
  getGameById: GameActions.getById,
  getGameByCode: GameActions.getGameByCode,
  revealLeaderboard: GameActions.revealLeaderboard,
  addGameToVisitedLeaderBoard: GameActions.addGameToVisitedLeaderBoard,
  setUpdatedResult: GameActions.setUpdatedResult,
  setLeaderboardRevealResult: GameActions.setLeaderboardRevealResult,
  setGameFinished: GameActions.setGameFinished,
  getHandicapsByRuleId: HandicapActions.getHandicapsByRuleId,
  getTournamentGames: TournamentActions.getTournamentGames,
})(withStyles(styles)(LeaderboardWithScroll));

export default ConnectedIndividualLeaderBoard as React.ComponentType<IndividualLeaderBoardOwnProps>;
